import request from '@/api/config/request'

const prex = "api/pessoas/usuarios/";

export function usuarioRenovaToken() {
    return request({
        url: `${prex}renova_token`,
        method: 'get'
    })
}